/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';

// assets
import iconCloseX from '../../../assets/img/icon-close-x.svg';

import './modal.css';

const Modal = ({ children, isOpen, closeModal, unableToClose, closeEscKey, closeClickOutside }) => {
  useEffect(() => {
    if (!unableToClose && closeEscKey) {
      const closeKeyDown = (e) => {
        if (e.keyCode === 27) {
          closeModal();
        }
      };
      window.addEventListener('keydown', closeKeyDown);
      return () => window.removeEventListener('keydown', closeKeyDown);
    }
  }, []);

  const handleClickKeypressInModalContent = (e) => e.stopPropagation();
  const handleClickCloseModal = () => {
    if (!unableToClose && closeClickOutside) closeModal();
  };

  return (
    <section
      onClick={handleClickCloseModal}
      className={`modal-container ${isOpen ? 'modal-container--is-open' : ''}`}
    >
      <section
        onClick={handleClickKeypressInModalContent}
        className="modal-content"
      >
        {!unableToClose && (
          <button type="button" className="modal-close" onClick={closeModal}>
            <img src={iconCloseX} alt="" width="14" />
          </button>
        )}
        {children}
      </section>
    </section>
  );
};

export default Modal;